import { IconProps } from "./types";

export function Email({ size = 20 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="-949 951 100 125">
      <path
        fill="currentColor"
        d="M-946.5,967v67.9l95,0V967L-946.5,967z M-899,1008.8l-36.7-35.1l73.5,0L-899,1008.8z M-858.1,978.9v46.8l-24.5-23.4    L-858.1,978.9z M-915.4,1002.3l-24.5,23.4v-46.8L-915.4,1002.3z M-910.6,1006.9l11.6,11.1l11.6-11.1l22.4,21.5h-68.1    L-910.6,1006.9z"
      />
    </svg>
  );
}
